import React from 'react'
import { Route, Switch } from 'react-router-dom'
import ProductOptionDetailsList from "./ProductOptionDetailsList";
import ProductOptionDetailsEdit from "./ProductOptionDetailsEdit";
import ProductOptionDetailsForm from "./ProductOptionDetailsForm";
import ProductOptionDetailsAdd from "./ProductOptionDetailsAdd";

export default () => {
    return {
        routes: [
            {
                path: '/options',
                render: ({ match }) => (
                    <Switch>
                        <Route path={`${match.url}/:id/details`} exact component={ProductOptionDetailsList} />
                        <Route path={`${match.url}/:id/details/add`} exact>
                            {props => <ProductOptionDetailsAdd {...props} ProductOptionDetailsForm={ProductOptionDetailsForm} />}
                        </Route>
                        <Route path={`${match.url}/:id/details/:detailId`} exact>
                            {props => <ProductOptionDetailsEdit {...props} ProductOptionDetailsForm={ProductOptionDetailsForm} />}
                        </Route>
                    </Switch>
                ),
            }
        ]
    }
}